import { useMutation, useQueryClient } from 'react-query';
import * as userApi from 'resources/user/user.api';

export default function useUpdateCurrentUserMilestonesSorting() {
  const queryClient = useQueryClient();

  return useMutation(
    ({ milestonesSorting }) => userApi.updateMilestonesSorting({ milestonesSorting }),
    {
      onSuccess: async () => {
        queryClient.invalidateQueries('user.currentUser');
      },
    },
  );
}
